export default "__VITE_ASSET__w$P0EFnU__"